
import { Company } from '@/lib/types';

interface CompanyDetailsCardProps {
  companyData: any;
}

export function CompanyDetailsCard({ companyData }: CompanyDetailsCardProps) {
  return (
    <div>
      <h3 className="text-lg font-medium mb-2">Company Details</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-muted-foreground">Company Name</p>
          <p className="font-medium">{companyData.name}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Location</p>
          <p className="font-medium">{companyData.locations?.[0] || 'Not specified'}</p>
        </div>
        <div className="md:col-span-2">
          <p className="text-sm text-muted-foreground">Staff Size</p>
          <p className="font-medium">{companyData.staff_size || 'Not specified'}</p>
        </div>
      </div>
    </div>
  );
}
